export enum DffHighchartsExtras {
    more,
    bullet,
    drilldown,
    exporting,
    noDataToDisplay,
    accessibility
}

export async function dffRenderHighcharts(
    options: import("highcharts").Options,
    ...extras: DffHighchartsExtras[]
): Promise<typeof import("highcharts")> {
    const hc = await dffImportHighcharts(...extras);
    hc.chart(options);
    return hc;
}

// TODO 14420: Check if type still works as intended
export async function dffImportHighcharts(...extras: DffHighchartsExtras[]): Promise<typeof import("highcharts")> {
    const hc = await import("highcharts");
    if (extras.includes(DffHighchartsExtras.more)) {
        ((await import("highcharts/highcharts-more")) as any).default(hc);
    }
    if (extras.includes(DffHighchartsExtras.accessibility)) {
        ((await import("highcharts/modules/accessibility")) as any).default(hc);
    }
    if (extras.includes(DffHighchartsExtras.bullet)) {
        ((await import("highcharts/modules/bullet")) as any).default(hc);
    }
    if (extras.includes(DffHighchartsExtras.drilldown)) {
        ((await import("highcharts/modules/drilldown")) as any).default(hc);
    }
    if (extras.includes(DffHighchartsExtras.exporting)) {
        ((await import("highcharts/modules/exporting")) as any).default(hc);
    }
    if (extras.includes(DffHighchartsExtras.noDataToDisplay)) {
        ((await import("highcharts/modules/no-data-to-display")) as any).default(hc);
    }
    return hc;
}

export function dffHighchartsRemoveAllSeries(chart: any): void {
    while (chart.series.length) {
        chart.series[0].remove();
    }
}

export function dffHighchartsRemoveSeries(chart: any, seriesId: string): void {
    const series = chart.get(seriesId);
    if (series) {
        series.remove(false);
    }
}

export function dffHighchartsSetSeries(chart: any, seriesOptions: { id: string; [name: string]: any }): any {
    const series = chart.get(seriesOptions.id) || chart.addSeries(seriesOptions);
    series.update(seriesOptions, false);
    return series;
}

export function dffShowHide(element: any, show: boolean): void {
    if (show) {
        element.show();
    } else {
        element.hide();
    }
}
